import { Box } from "@mui/material";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import React from "react";
import { useSelector } from "react-redux";
import muiConfig from '../../../assets/MuiConfig.json'

export default function Table() {
  const state = useSelector((store) => store.analyze);
  const { fourPLDataPrepared } = state;
  const { rows, columns } = fourPLDataPrepared;

  return (
    <Box sx={{ mt: 3 }}>
      <DataGridPro
        rows={rows}
        columns={columns}
        sx={{
          '& .MuiDataGrid-columnHeader':{
            whiteSpace: 'normal',
            lineHeight: '1.2',
            //textAlign: 'center',
          },
          '& .MuiDataGrid-columnHeaderTitle':{
            overflow:'unset',
            whiteSpace: 'normal',
            display: 'block',
          },
        }}
        disableColumnMenu
        initialState={{
					pagination: { paginationModel: { pageSize:20, page:0 }}
				}}
				pagination
				pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
        //slots={{ toolbar: GridToolbar }}
      />
    </Box>
  );
}
